<template>
  <div>
    <fieldset class="border p-3">
      <legend class="auto-wp">
        <small style="font-size: 15px; font-weight: bold">manage truck requisitions</small>
      </legend>
      <div></div>
      <div>
        <div class="requisitionsLoader">
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          <i class="fa fa-spinner fa-spin" style="font-size: 24px; color: blue"></i>loading requisitions...
        </div>
        <vue-good-table
          :columns="columns"
          :rows="systemRequisitions"
          :fixed-header="true"
          :pagination-options="{
            enabled: true,
            mode: 'records',
            perPage: 6,
            position: 'bottom',
            perPageDropdown: [3, 7, 9],
            dropdownAllowAll: false,
            setCurrentPage: 1,
            nextLabel: 'next',
            prevLabel: 'prev',
            rowsPerPageLabel: 'Rows per page',
            ofLabel: 'of',
            pageLabel: 'page', // for 'pages' mode
            allLabel: 'All',
          }"
        >
          <template slot="table-row" slot-scope="props">
            <span v-if="props.column.field == 'Bondtracking'">
              <button
                v-b-tooltip.hover.bottom="'Add bondtracking!'"
                class="btn btn-primary btn-sm btn-rounded"
                @click="viewRequisition(props.row.id)"
              >
                <i class="fa fa-plus"></i> Add bondtracking
              </button>
            </span>
            <span v-else-if="props.column.field == 'Trucktracking'">
              <button
                v-b-tooltip.hover.bottom="'Truck tracking!'"
                class="btn btn-primary btn-sm btn-rounded"
                @click="viewRequisitiontruck(props.row.id)"
              >
                <i class="fa fa-globe"></i> Truck tracking
              </button>
            </span>
            <span v-else-if="props.column.field == 'ContainerInterchange'">
              <button
                v-b-tooltip.hover.bottom="'Add Interchange!'"
                class="btn btn-primary btn-sm btn-rounded"
                @click="viewContainerinterchange(props.row.id)"
              >
                <i class="fa-file-pdf-o"></i> Container interchange
              </button>
            </span>
          </template>
        </vue-good-table>
      </div>
    </fieldset>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
export default {
  data() {
    return {
      columns: [
        {
          label: "File code",
          field: "file_code",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter file reference"
          }
        },
        {
          label: "Customer name",
          field: "customer_name",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter customer"
          }
        },
        {
          label: "Email",
          field: "email_address",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter email"
          }
        },
        {
          label: "Bill of landing",
          field: "bill_landing",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "Filter bill of landing"
          }
        },
        {
          label: "Cargo no",
          field: "container_no",
          type: "text",
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: "cargo number"
          }
        },
        {
          label: "Truck no",
          field: "truck_no",
          type: "text"
        },
        {
          label: "Tailer no",
          field: "trailer_no",
          type: "text"
        },
        {
          label: "T812 entry",
          field: "t812_entry",
          type: "text"
        },

        {
          label: "Bond tracking",
          field: "Bondtracking",
          width: "122px",
          html: true
        },
        {
          label: "Truck tracking",
          field: "Trucktracking",
          width: "122px",
          html: true
        },
        {
          label: "Container interchange",
          field: "ContainerInterchange",
          width: "122px",
          html: true
        }
      ]
    };
  },
  created() {
    this.loadRequisitions();
  },
  computed: {
    ...mapGetters(["systemRequisitions"])
  },
  methods: {
    ...mapActions([
      "loadRequisitions",
      "viewRequisition",
      "viewRequisitiontruck",
      "viewContainerinterchange"
    ])
  }
};
</script>


// WEBPACK FOOTER //
// src/requisitions/managerequisitions.vue